import { ILoginParams, ILoginResponse } from '@webtrader/core/api/user/login';
import request from '@webtrader/core/request';
import { checkIsNative } from '@webtrader/core/validators/device';

export interface IMT5LoginParams extends Omit<ILoginParams, 'userId'> {
  userId: number;
}

interface IMT5LoginResponse extends ILoginResponse {}

export default {
  demoLogin: (params: IMT5LoginParams) => {
    return checkIsNative()
      ? request.post<IMT5LoginResponse>('/api/auth/v2/metatrader5/demo/mobile/login', params)
      : request.post<IMT5LoginResponse>('/api/auth/v2/metatrader5/demo/login', params);
  },
  liveLogin: (params: IMT5LoginParams) => {
    return checkIsNative()
      ? request.post<IMT5LoginResponse>('/api/auth/v2/metatrader5/live/mobile/login', params)
      : request.post<IMT5LoginResponse>('/api/auth/v2/metatrader5/live/login', params);
  }
};
